export const reCaptchaKeys = process.env.VUE_APP_RECAPTCHA_CREDENTIALS
